// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/listing.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Property, Query } from "./query_pb.js";

/**
 * Types of field ordering for listing requests.
 *
 * @generated from enum ai.h2o.deploy.Order
 */
export const Order = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.deploy.Order",
  [
    {no: 0, name: "ASCENDING"},
    {no: 1, name: "DESCENDING"},
  ],
);

/**
 * Generic paging request portion needed for listing in presence of concurrent
 * modifications.
 *
 * @generated from message ai.h2o.deploy.PagingRequest
 */
export const PagingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.PagingRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Generic paging response portion needed for listing in presence of concurrent
 * modifications.
 *
 * @generated from message ai.h2o.deploy.PagingResponse
 */
export const PagingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.PagingResponse",
  () => [
    { no: 1, name: "next_page_token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Generic sorting request specifying the ordering of a request results from the
 * most to the least
 * important properties.
 *
 * @generated from message ai.h2o.deploy.SortingRequest
 */
export const SortingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.SortingRequest",
  () => [
    { no: 1, name: "property", kind: "message", T: SortProperty, repeated: true },
  ],
);

/**
 * Defines a single property to sort requests results on together with the
 * desired ordering
 * direction.
 *
 * @generated from message ai.h2o.deploy.SortProperty
 */
export const SortProperty = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.SortProperty",
  () => [
    { no: 1, name: "property", kind: "message", T: Property },
    { no: 2, name: "order", kind: "enum", T: proto3.getEnumType(Order) },
  ],
);

/**
 * Generic filter request specifying criteria on the request results.
 *
 * @generated from message ai.h2o.deploy.FilterRequest
 */
export const FilterRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.FilterRequest",
  () => [
    { no: 1, name: "query", kind: "message", T: Query },
  ],
);

